import { Activity } from "lucide-react";
import { WellbeingRoute } from "./routes/WellbeingRoute";

export const WELLBEING_ROUTES = {
  wellbeing: {
    key: "wellbeing",
    path: "/wellbeing",
    title: "Well-being",
    icon: <Activity size={17} />,
    element: <WellbeingRoute />
  }
};
